<div class="field" *ngIf="searchField">
  <span class="p-float-label">
    <p-autoComplete
      [inputStyleClass]="'input-filters'"
      [type]="inputType"
      id="autocomplete"
      [suggestions]="filteredEntities"
      [dropdown]="showDropDown"
      [formControl]="control"
      [field]="displayWithEntityFn"
      [showEmptyMessage]="true"
      [showClear]="true"
      [dropdown]="true"
      (onClear)="clearSelectValue()"
      (onDropdownClick)="onLoad(control.value)"
      [emptyMessage]="'Nenhum resultado encontrado!'"
      [readonly]="readonly"
    >
      <ng-template pTemplate="item" let-entity>
        {{ displayWithEntityFn(entity) }}
      </ng-template>
      <ng-template pTemplate="footer">
        <button
          pButton
          pRipple
          *ngIf="insertType && actionState"
          label="Adicionar agora"
          icon="pi pi-plus"
          iconPos="right"
          (click)="
            openDialogAddEntity ? openDialogAddEntity() : openDialogFast()
          "
          class="p-button-text p-button-outlined p-button-primary width-100"
        ></button>
      </ng-template>
    </p-autoComplete>
    <label for="autocomplete">{{ placeholder }}</label>
  </span>
</div>
<div *ngIf="!searchField">
  <mat-form-field
    class="w-100"
    (click)="inputFastAuto.select()"
    appearance="outline"
  >
    <mat-label (click)="inputFastAuto.select()">
      {{ placeholder }}
    </mat-label>
    <input
      #inputFastAuto
      matInput
      #trigger="matAutocompleteTrigger"
      (click)="inputFastAuto.select()"
      [formControl]="control"
      [matAutocomplete]="auto"
      [type]="inputType"
      (keydown)="
        useOnlyNumbers ? validateOnlyNumbers($event) : onKeyDown($event)
      "
      (blur)="blur.emit($event)"
      (keyup)="enterSearch($event)"
      [readonly]="readonly"
      name="fast-autcomplete"
      autocomplete="off"
    />
    <button
      *ngIf="showBtnDialog"
      mat-icon-button
      matSuffix
      (click)="dialogClick()"
    >
      <mat-icon color="primary">{{ btnIcon }}</mat-icon>
    </button>
    <p-button
      matSuffix
      *ngIf="
        !showBtnDialog &&
        !readonly &&
        !control.hasError('isEmptyValue') &&
        controlIsEnabled
      "
      pRipple
      [icon]="getBtnIcon()"
      class="mb-1 p-button-sm"
      [severity]="getBtnSeverity()"
      text
      rounded
      (click)="getBtnAction()"
    ></p-button>
  </mat-form-field>
  <small class="p-error" *ngIf="control.invalid && control.touched">
    {{ messages[getKey()] }}
  </small>
</div>
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayWithEntityFn"
  (optionActivated)="onOptionActivated($event)"
>
  <!-- <mat-option
    disabled
    *ngIf="forcedNotShowOptions ? isLoading && !notShowOptions : isLoading"
    class="is-loading"
  >
    <div class="flex justify-content-center align-items-center width-100">
      <span>Carregando...</span>
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
      ></p-progressSpinner>
    </div>
  </mat-option> -->

  <mat-option disabled *ngIf="noResults">
    {{
      control.value
        ? 'Não encontramos nada com ' + control.value
        : 'Nenhum resultado disponível!'
    }}
  </mat-option>
  <mat-option
    id="addBtn"
    *ngIf="insertType && actionState"
    [ngClass]="{ 'btn-add-option': isBtnActive }"
    (click)="openDialogAddEntity ? openDialogAddEntity() : openDialogFast()"
  >
    <div class="flex align-items-center text-black-alpha-80">
      <i class="mdi mdi-plus mr-2"></i>
      Adicionar novo
    </div>
  </mat-option>
  <ng-container *ngIf="!notShowOptions && !noResults">
    <mat-option
      #option
      (click)="confirmSelection(entity)"
      *ngFor="let entity of filteredEntities"
      [value]="entity"
    >
      {{ displayWithEntityFn(entity) }}
    </mat-option>
  </ng-container>
</mat-autocomplete>
